export const ENUM_PHOTO_PLANT = 2
export const ENUM_PHOTO_AREA_LOCATION = 3
export const ENUM_PHOTO_BANNER = 1
